<script>
import CompanyResource from '../resources/company'

export default {
    components: {},
    data() {
        return {
            loading: true,
            imageResource: null
        }
    },
    props: {
        companyResource: {
            type: CompanyResource,
            required: true
        },
        size: {
            required: false,
            default: '4em'
        },
    },
    watch: {
        companyResource() {
            this.imageResource = null
        }
    },
    methods: {
        getSource() {
            if(this.imageResource) {
                return String(this.imageResource) || ''
            } else if(this.companyResource.get('website')) {
                let url = this.companyResource.get('website').replace(/https?:\/\//gi, '')
                return `https://logo.clearbit.com/${url}?size=500`
            } else {
                return ''
            }
        }
    },
    async mounted() {
        let imageManager = this.companyResource.rel('image')
        await imageManager.resolve()
        this.imageResource = imageManager.resource
        this.loading = false
    }
}
</script>

<template>
    <div class="company-image">
        <b-avatar rounded variant="light" :size="size" :src="getSource()" />
    </div>
</template>

<style lang="scss" scoped>

</style>
